import { isEventStreamLive } from './useEventSource';

/**
 * Refetch policy for a query whose changes are PUSHED (SSE → EventRouter invalidates its key).
 *
 * Best practice: the push drives the screen. While the stream is open the query only keeps a
 * slow safety net (a dropped or out-of-order event cannot strand the screen for long; the
 * reconnect already invalidates everything); only when the stream is DOWN does it fall back
 * to its own fast interval. Nothing to wait for → no timer at all.
 *
 *   refetchInterval: (q) => whileWaiting(q.state.data?.status === 'running', 10_000)
 */
export const PUSH_SAFETY_NET_MS = 60_000;

export function whileWaiting(waiting: boolean, fallbackMs: number): number | false {
  if (!waiting) return false;
  return isEventStreamLive() ? Math.max(fallbackMs, PUSH_SAFETY_NET_MS) : fallbackMs;
}
